import React, { useState } from "react";
import s from "./ActionsPopOver.module.scss";
import { generateConfirmation } from "../../../../../../../../global components/DestructiveModal/DestruvtiveModal";
import ReusableModal from "../../../../../../../../global components/Modal/Modal";
import TwilloModalContent from "../TwilloModalContent";
import DeclineRequestForm from "../DeclineRequestForm";
import { generateResult } from "../../../../../../../../global components/ResultModal/ResultModal";
type PropType = {
  id: string;
  mutate: () => void;
  code: string;
  country: string;
  status: string;
};
function ActionsPopOver({ id, mutate, code, country, status }: PropType) {
  const [open, setOpen] = useState<boolean>(false);
  const [openDeclinationModal, setOpenDeclinationModal] =
    useState<boolean>(false);
  const handleModal = () => {
    setOpen((prev) => !prev);
  };
  const handleDeclination = () => {
    setOpenDeclinationModal((prev) => !prev);
  };
  return (
    <>
      <div className={s.wrapper}>
        <div
          className={s.item}
          onClick={() =>
            status === "rejected" || status === "approved"
              ? generateResult(
                  "error",
                  `You can not approve a ${status} request`
                )
              : handleModal()
          }
        >
          Assign
        </div>
        <div
          className={s.item}
          onClick={() =>
            status === "rejected" || status === "approved"
              ? generateResult(
                  "error",
                  `You can not decline a ${status} request`
                )
              : generateConfirmation(
                  "Decline request",
                  "You are about to decline the request for this user. This action cannot be undone.",
                  async () => handleDeclination(),
                  true,
                  "decline"
                )
          }
        >
          Decline
        </div>
      </div>
      <ReusableModal
        title={""}
        isModalOpen={open}
        handleModal={handleModal}
        width={682}
        classNames={{
          header: s.modalHeader,
          wrapper: s.modalHeader,
          body: s.modalHeader,
          content: s.modalHeader,
        }}
        closeIcon={<></>}
      >
        <TwilloModalContent
          mutate={mutate}
          assignId={id}
          closeModal={handleModal}
          areaCode={code}
          country={country}
        />
      </ReusableModal>
      <ReusableModal
        title={""}
        isModalOpen={openDeclinationModal}
        handleModal={handleDeclination}
        width={437}
        closable={false}
        maskClosable={false}
      >
        <DeclineRequestForm
          mutate={mutate}
          id={id}
          closeModal={handleDeclination}
        />
      </ReusableModal>
    </>
  );
}

export default ActionsPopOver;
